<template>
  <div id="app">
    <main class="app-main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss">
@use "@monolith/styles";
body {
  background-color: var(--primary-colour);
  color: var(--text-colour);
}
</style>
